import './ui/domContentLoaded';
import './ui/standaloneMode';
import './ui/signaturePad';
import './ui/register';
import './ui/documentReady';
